// Safety-net snapshot of the Sanity-managed tour-package slugs.
//
// Why this exists: tour-package detail pages sourced from Sanity are only
// prerendered when Sanity responds during the build. If Sanity is briefly
// unreachable at build time, getStaticPaths would fall back to LOCAL packages
// only and these URLs would drop out of that build (→ 404 / removed from
// sitemap). Feeding this committed list into getStaticPaths guarantees they are
// ALWAYS prerendered, regardless of Sanity availability at build time.
//
// Keep it current: after adding/removing packages in Sanity Studio, run
//   node scripts/refresh-sanity-slugs.mjs
// (from an environment that can reach Sanity) to regenerate this file.
export const SANITY_PACKAGE_SLUGS = [
  'armenia-short-and-sweet-escape',
  'baku-with-gobustan',
  'dubai-abu-dhabi-private-tour-package-5-days',
  'dubai-private-tour-package-4-days',
  'serene-maldives-cinnamon-dhonveli',
  'spectacular-phuket-and-krabi',
];
